import type { CategoryDefinition } from 'components/Category'

export const categories: Array<CategoryDefinition> = [
	{
		id: 'ACCOMMODATION',
		title: 'Accommodation',
		description:
			'Payments for travel accommodation, including hotels, hostels, bed-and-breakfasts, resorts and vacation or homestay rentals.',
		examples: ['Comwell', 'CABINN', 'Next House Copenhagen'],
	},
	{
		id: 'ADDITIONAL_PAY',
		title: 'Bonuses & additional pay',
		description:
			'Employment earnings specifically identified as bonuses, commission, overtime pay or employee profit-sharing. Payments may be regular or one-off.',
		examples: ['Performance bonus or employee profit-sharing payout', 'Sales commission payment', 'Overtime pay'],
	},
	{
		id: 'ADULT_CONTENT_STREAMING',
		title: 'Adult streaming',
		description: 'Payments for adult-content streaming and adult-media subscriptions or memberships.',
		examples: ['Subscription to an adult-video streaming platform', 'Paid membership for access to adult content'],
	},
	{
		id: 'AIR_TRAVEL',
		title: 'Air travel',
		description:
			'Payments associated with airlines and air travel, including flight tickets and airline-related travel charges.',
		examples: ['SAS', 'Atlantic Airways', 'Air Greenland'],
	},
	{
		id: 'ALIMONY',
		title: 'Alimony',
		description: 'Incoming alimony or spousal-support payments.',
		examples: ['Monthly spousal-support payment received', 'Court-ordered alimony payment received'],
	},
	{
		id: 'AMUSEMENT_PARKS',
		title: 'Amusement parks',
		description: 'Payments to amusement and theme parks, including admission, passes and recurring memberships.',
		examples: ['Tivoli', 'LEGOLAND', 'Djurs Sommerland'],
	},
	{
		id: 'ANIMAL_CARE',
		title: 'Pets & animal care',
		description:
			'Payments for pets and animal care, including veterinary care, pet supplies, grooming, pet plans and animal-related memberships.',
		examples: ['AniCura', 'Maxi Zoo', 'VetFamily / VetPlan'],
	},
	{
		id: 'ARTS_CRAFTS_AND_HOBBY_SUPPLIES',
		title: 'Arts, crafts & hobby supplies',
		description:
			'Purchases of art, craft and hobby materials, including specialist hobby supplies, stationery and creative materials.',
		examples: ['Rito.dk', 'Stelling', 'Smyks'],
	},
	{
		id: 'ASSOCIATIONS',
		title: 'Associations',
		description:
			'Payments to member-based associations, such as civic, consumer, hobby, fan or interest organizations.',
		examples: ['Ældre Sagen', 'Forbrugerrådet TÆNK', 'Dansk Camping Union'],
	},
	{
		id: 'BANK_FEES',
		title: 'Bank fees',
		description:
			'Fees charged by banks or card/account providers for account, card, transfer, currency or other banking services.',
		examples: [
			'Lunar Bank service fee',
			'Annual debit- or credit-card fee',
			'Bank transfer or currency-conversion fee',
		],
	},
	{
		id: 'BARS_AND_NIGHTCLUBS',
		title: 'Bars & nightclubs',
		description: 'Payments at bars, pubs, nightclubs, wine bars and similar nightlife venues.',
		examples: ['Proud Mary', 'Old Irish Pub', 'Heidis Bier Bar'],
	},
	{
		id: 'BEAUTY_CARE',
		title: 'Beauty care',
		description:
			'Payments to beauty and grooming providers and merchants, covering services and products such as hair care, cosmetics, tanning, nail care, skincare and salon-based beauty treatments.',
		examples: ['Matas', 'ClubTan', 'Trend of Hair VIP Klub'],
	},
	{
		id: 'BEER_WINE_AND_SPIRITS',
		title: 'Beer, wine & spirits',
		description:
			'Purchases from merchants primarily associated with alcoholic beverages, such as wine shops, liquor stores, breweries and specialist beer retailers.',
		examples: ['Vinspecialisten', 'Supervin.dk', 'Philipson Wine'],
	},
	{
		id: 'BICYCLE_AND_SCOOTER_RENTAL',
		title: 'Bike & scooter rental',
		description: 'Payments for renting or subscribing to bicycles and scooters, including shared-mobility services.',
		examples: ['Swapfiets', 'Voi', 'Donkey Republic'],
	},
	{
		id: 'BOOKS_AND_PUBLICATIONS',
		title: 'Books & publications',
		description:
			'Payments for books, newspapers, magazines, book summaries and other reading-focused publications or subscriptions, in physical or digital form.',
		examples: ['Politiken', 'Berlingske Media', 'Blinkist'],
	},
	{
		id: 'BOX_SUBSCRIPTIONS',
		title: 'Subscription boxes',
		description:
			'Subscriptions for recurring deliveries of physical products, including meal boxes, personal-care products and replenishment supplies.',
		examples: ['Aarstiderne', 'HP Instant Ink', 'Barberklingen'],
	},
	{
		id: 'BUSINESS_GOODS_AND_SERVICES',
		title: 'Business goods & services',
		description:
			'Payments for goods and services primarily used in a business context, including business software, workspace, marketing, administration and operational services.',
		examples: ['OnlinePOS', 'The Blue Office', 'LEIRegister'],
	},
	{
		id: 'CAFES',
		title: 'Cafes',
		description: 'Purchases at cafes, coffee shops, tea houses, juice bars and similar light-refreshment venues.',
		examples: ['Espresso House', 'Joe & The Juice', 'Independent coffee shop or tea house'],
	},
	{
		id: 'CAR_RENTAL',
		title: 'Car rental',
		description: 'Payments for short-term car rentals and car-sharing services.',
		examples: ['Oscar car rental', 'Hyre', 'Share Now'],
	},
	{
		id: 'CASH_WITHDRAWALS',
		title: 'Cash withdrawals',
		description: 'Cash withdrawals from a bank account, typically through an ATM or bank branch.',
		examples: ['ATM cash withdrawal', 'Cash withdrawal at a bank branch'],
	},
	{
		id: 'CATERING',
		title: 'Catering',
		description:
			'Payments for prepared meals and food-service arrangements for workplaces, canteens, events and other catered occasions.',
		examples: ['DinnerDeluxe', 'Mr. Mums', 'Kanpla canteen payment'],
	},
	{
		id: 'CHARITY_AND_DONATIONS',
		title: 'Charity & donations',
		description:
			'One-off or recurring donations and contributions to charities, nonprofit organizations and similar causes.',
		examples: ['Børns Vilkår', 'Red Barnet', 'UNICEF'],
	},
	{
		id: 'CHILDCARE_ALLOWANCE',
		title: 'Childcare allowance',
		description: 'Incoming public allowance or subsidy specifically related to childcare costs.',
		examples: ['Public subsidy toward daycare costs', 'Childcare-support allowance'],
	},
	{
		id: 'CHILDCARE_SERVICES',
		title: 'Childcare',
		description: 'Payments for childcare services such as daycare, nursery and after-school care.',
		examples: ['Københavns Kommune childcare', 'Aarhus Kommune childcare', 'Børnehuset Bøgegården'],
	},
	{
		id: 'CHILD_ALLOWANCE',
		title: 'Child allowance',
		description: 'Incoming public child-allowance or child-benefit payments.',
		examples: ['Periodic government child-benefit payment', 'Family allowance deposit'],
	},
	{
		id: 'CHILD_SUPPORT',
		title: 'Child support',
		description: 'Child-support payments, including both child support paid and child support received.',
		examples: [
			'Monthly child-support payment to another parent',
			'Incoming child-support payment',
			'Government-facilitated child-support payment',
		],
	},
	{
		id: 'CINEMA_AND_THEATER',
		title: 'Movies & theater',
		description:
			'Payments for movie theaters and performing-arts venues, including cinema, plays, musicals, opera and theater.',
		examples: ['Nordisk Film Biografer', 'BIG BIO', 'Det Kongelige Teater'],
	},
	{
		id: 'CLOTHING',
		title: 'Clothing',
		description:
			"Purchases of clothing and apparel, including general fashion, children's clothing, lingerie, seasonal wear and similar garments.",
		examples: ['H&M', 'Zara', 'Boozt'],
	},
	{
		id: 'CONCERTS_AND_LIVE_EVENTS',
		title: 'Concerts & live events',
		description: 'Payments for concert tickets, festival passes, live performances and related event access.',
		examples: ['Roskilde Festival', 'VEGA', 'Copenhell'],
	},
	{
		id: 'CONSUMER_LOAN',
		title: 'Consumer loan',
		description:
			'Repayments on consumer loans and unsecured consumer-finance products where the loan purpose is identified as consumer credit.',
		examples: ['Facit Bank', 'Ferratum Bank', 'Cashper'],
	},
	{
		id: 'CONVENIENCE_STORES',
		title: 'Convenience stores',
		description: 'Purchases from convenience stores, kiosks and similar small-format general retailers.',
		examples: ['7-Eleven', 'UFO Kiosk', 'Local convenience store or kiosk'],
	},
	{
		id: 'CREDIT_CARD_REPAYMENTS',
		title: 'Credit card repayments',
		description: 'Payments made toward an outstanding credit-card balance.',
		examples: [
			'Eurocard bill payment',
			'Monthly credit-card balance settlement',
			'Partial repayment of an outstanding credit-card balance',
		],
	},
	{
		id: 'DATING',
		title: 'Dating',
		description: 'Payments for dating apps, websites and subscription-based dating services.',
		examples: ['Tinder', 'Scor.dk', 'Single.dk'],
	},
	{
		id: 'DEBT_COLLECTION',
		title: 'Debt collection',
		description: 'Payments to debt-collection agencies or collection arrangements for overdue debt.',
		examples: ['Lowell', 'Collectia', 'Intrum'],
	},
	{
		id: 'DENTAL_CARE',
		title: 'Dental care',
		description: 'Payments for dental treatment and dental-clinic services.',
		examples: ['Tandlægen.dk', 'ORIS Tandlægerne', 'Smil med Østergaard'],
	},
	{
		id: 'DEPARTMENT_STORES_AND_MALLS',
		title: 'Department stores & malls',
		description:
			'Retail purchases associated with department stores, multi-category discount retailers, shopping malls and outlet centers.',
		examples: ['Salling', 'Magasin du Nord', 'Ringsted Outlet'],
	},
	{
		id: 'DEPOSITS',
		title: 'Deposits',
		description: 'Cash or similar deposits made into an account.',
		examples: ['Cash deposit at a bank branch', 'Cash deposit through an ATM'],
	},
	{
		id: 'DIGITAL_PRODUCTS_AND_SERVICES',
		title: 'Digital products & services',
		description:
			'Payments for digital products and online services, including software, cloud storage, web hosting, apps, digital games and other online tools or subscriptions.',
		examples: ['Google One', 'Simply.com', 'Microsoft 365'],
	},
	{
		id: 'DISCOUNT_CLUB',
		title: 'Discount club',
		description: 'Paid memberships that provide discounts, benefits, member pricing or similar membership advantages.',
		examples: ['Wolt+', 'Matas Plus', 'Luxplus'],
	},
	{
		id: 'EDUCATIONAL_INSTITUTIONS',
		title: 'Educational institutions',
		description:
			'Payments directly associated with schools, colleges, universities and other educational institutions, such as tuition, school fees and institutional charges.',
		examples: ['N. Zahles Skole', 'EUC Sjælland', 'Aarhus Universitet'],
	},
	{
		id: 'EDUCATION_AND_TRAINING',
		title: 'Education & training',
		description:
			'Payments for courses, tutoring, professional training, online learning and self-directed education, including learning-platform subscriptions and individual classes.',
		examples: ['Studybox', 'MasterClass', 'Udemy'],
	},
	{
		id: 'ELECTRICITY_SERVICES',
		title: 'Electricity',
		description:
			'Payments for electricity supply, including electricity bills and recurring charges from electricity providers.',
		examples: ['Vindstød', 'Modstrøm', 'Jysk Energi'],
	},
	{
		id: 'ELECTRIC_VEHICLE_CHARGING',
		title: 'EV charging',
		description:
			'Payments for electric-vehicle charging, including individual charging sessions and charging subscriptions.',
		examples: ['Clever', 'Spirii', 'Volkswagen We Charge'],
	},
	{
		id: 'ELECTRONICS',
		title: 'Electronics',
		description:
			'Purchases from consumer-electronics and appliance retailers, including computers, phones, cameras, audio/video equipment, home electronics and related hardware.',
		examples: ['Elgiganten', 'POWER', 'Proshop'],
	},
	{
		id: 'ELECTRONICS_REPAIR',
		title: 'Electronics repair',
		description: 'Payments to providers that repair or service electronic devices and equipment.',
		examples: [
			'Phone or tablet repair shop',
			'Computer repair workshop',
			'Television or audio-equipment repair provider',
		],
	},
	{
		id: 'ENTERTAINMENT_AND_RECREATION',
		title: 'Entertainment & recreation',
		description:
			'Payments for entertainment and recreation, including museums, zoos, play centers, games and family experiences, as well as related memberships and subscriptions.',
		examples: ['Aalborg Zoo', 'Experimentarium', 'Hermans Hule'],
	},
	{
		id: 'EQUIPMENT_RENTAL',
		title: 'Equipment rental',
		description:
			'Rental or leasing of equipment and devices, including household appliances, tools, musical instruments and medical equipment.',
		examples: ['White On', 'Piano Rent', 'Medical-equipment rental provider'],
	},
	{
		id: 'FASHION_ACCESSORIES',
		title: 'Fashion accessories',
		description: 'Purchases of fashion accessories, including handbags, wallets, luggage and related leather goods.',
		examples: ['NEYE', 'Helm', 'Bon Gout'],
	},
	{
		id: 'FAST_FOOD_AND_TAKEAWAY',
		title: 'Fast food & takeout',
		description: 'Payments for fast food, takeout, meal delivery, street food and similar quick-service meals.',
		examples: ["McDonald's", 'Just Eat', 'Sunset Boulevard'],
	},
	{
		id: 'FERRY',
		title: 'Ferry',
		description:
			'Payments for ferry crossings, including passenger and vehicle tickets, passes and ferry subscriptions.',
		examples: ['Ærøfærgerne', 'Østre Færge', 'Bornholmslinjen'],
	},
	{
		id: 'FINANCIAL_SERVICES',
		title: 'Financial services',
		description:
			'Payments for financial services such as advisory services, financial platforms, brokerage services and personal-finance services.',
		examples: ['Personal-finance platform', 'Brokerage service charge', 'Financial advisory provider'],
	},
	{
		id: 'FITNESS',
		title: 'Fitness',
		description:
			'Payments related to gyms, exercise and fitness activities, including gym memberships, CrossFit, yoga, Pilates, personal training and similar fitness services.',
		examples: ['PureGym', 'SATS', 'FitnessX'],
	},
	{
		id: 'FOOTWEAR',
		title: 'Footwear',
		description: 'Purchases of shoes and other footwear, together with shoe-repair and related footwear services.',
		examples: ['Skoringen', 'Deichmann', 'Runddelens Skomageri'],
	},
	{
		id: 'FUNERALS_AND_CEMETERIES',
		title: 'Funerals & cemeteries',
		description:
			'Payments for funerals, cremation, burial and cemetery services, including recurring grave-maintenance and cemetery charges.',
		examples: ['Hørsholm Kirkegård', 'Silkeborg Kirkegårde og Krematorium', 'Funeral home'],
	},
	{
		id: 'GAMBLING_AND_BETTING',
		title: 'Gambling & betting',
		description: 'Payments related to gambling, lotteries, casinos and betting activity.',
		examples: ['Danske Spil', 'Det Danske Klasselotteri', 'bet365'],
	},
	{
		id: 'GIFTS',
		title: 'Gifts',
		description: 'Money received as a gift.',
		examples: [
			'Birthday money received from a relative',
			'Wedding gift received as a bank transfer',
			'Cash gift from a family member',
		],
	},
	{
		id: 'GOVERNMENT_FEES_AND_SERVICES',
		title: 'Government fees & services',
		description:
			'Payments to public authorities for administrative services, applications, fees, fines and other government charges.',
		examples: ['Nyidanmark.dk application fee', 'Court or administrative fee', 'Government fine'],
	},
	{
		id: 'GRANTS',
		title: 'Grants',
		description: 'Incoming non-repayable grant funding from public, private or organizational sources.',
		examples: ['Foundation grant', 'Project-funding grant', 'Organizational grant payment'],
	},
	{
		id: 'GROCERIES_OTHER',
		title: 'Other food & groceries',
		description:
			'Other food and grocery-related purchases, including food markets, grocery cooperatives, farm shops and similar food suppliers.',
		examples: ['Grocery cooperative', 'Farm shop or dairy-farm outlet', 'Food-market purchase'],
	},
	{
		id: 'HEALTHCARE',
		title: 'Healthcare',
		description:
			'Payments for medical and health services, treatments and health-related products, including physiotherapy, chiropractic care, mental-health services, nutrition, supplements and other therapy-related activity.',
		examples: ['NutraQ', 'Calm', 'Aarhus Osteopati'],
	},
	{
		id: 'HEALTH_INSURANCE',
		title: 'Health insurance',
		description: 'Premiums and recurring payments specifically identified as health-insurance coverage.',
		examples: ['Sygeforsikring "danmark"', 'Dansk Sundhedssikring'],
	},
	{
		id: 'HEATING_SERVICES',
		title: 'Heating',
		description: 'Payments for heating supply, including district-heating bills and charges from heating providers.',
		examples: ['Kredsløb', 'Fjernvarme Horsens', 'Skanderborg-Hørning Fjernvarme'],
	},
	{
		id: 'HOMEOWNERS_ASSOCIATION',
		title: 'Homeowners association',
		description:
			"Payments to homeowners' or property-owner associations, typically covering membership, shared-property obligations or common-area costs.",
		examples: ['Marielyst Grundejerforening', 'E/F Carlsberg Byen 2', 'E/F Gurreparken'],
	},
	{
		id: 'HOME_CARE',
		title: 'Home care',
		description:
			'Payments for care and practical support delivered in the home, including in-home care and related assistance services.',
		examples: ['Cura Pleje', 'In-home care provider', 'Home-support or assisted meal-service provider'],
	},
	{
		id: 'HOME_FURNISHINGS',
		title: 'Home furnishings',
		description: 'Purchases of furniture, home decor and kitchenware used to furnish or equip a home.',
		examples: ['IKEA', 'JYSK', 'Imerco'],
	},
	{
		id: 'HOME_IMPROVEMENT',
		title: 'Home improvement',
		description:
			'Purchases and services for improving a home and garden, including tools, building materials, fittings, plants, gardening supplies, landscaping and garden care.',
		examples: ['Bauhaus', 'Silvan', 'Plantorama'],
	},
	{
		id: 'HOME_MAINTENANCE',
		title: 'Home maintenance',
		description:
			'Payments for maintaining and repairing a home or property, including tradespeople and ongoing property services.',
		examples: ['60Pudser', 'MV Polering', 'Finlow VVS'],
	},
	{
		id: 'HOME_OTHER',
		title: 'Other home-related activity',
		description:
			'Other household or housing-related payments, including home-related charges for which the specific service or purpose is not identified.',
		examples: ['Household utility charge with no identified service type', 'Other home-related supplier payment'],
	},
	{
		id: 'HOME_SECURITY',
		title: 'Home security',
		description: 'Payments for home alarm, monitoring and security-system products or services.',
		examples: ['Verisure', 'G4S', 'ABS Alarm & Sikkerhed'],
	},
	{
		id: 'HOUSING_BENEFITS',
		title: 'Housing benefits',
		description:
			'Public financial support toward housing and rent costs, including housing benefits, rent subsidies and supplementary housing-support payments.',
		examples: ['Regular housing-benefit payment', 'Public rent subsidy', 'Supplementary payment toward housing costs'],
	},
	{
		id: 'HOUSING_COOPERATIVE',
		title: 'Housing cooperative',
		description: 'Payments to housing cooperatives or cooperative-housing associations.',
		examples: ['A/B JoJo', 'A/B Holmegaarden', 'AB Ingolf'],
	},
	{
		id: 'HOUSING_LOAN',
		title: 'Housing loan',
		description: 'Repayments on housing-related loans, such as bank loans used to finance a home.',
		examples: ['Jyske Bank Pantebrev', 'Husejernes Kreditlån', 'Jysk Ejendomskreditselskab'],
	},
	{
		id: 'INCOME_OTHER',
		title: 'Other income',
		description:
			'Other income that does not match a more specific income category, including extraordinary income receipts.',
		examples: ['One-off extraordinary income receipt', 'Income payment without a more specific source description'],
	},
	{
		id: 'INSTALLMENTS',
		title: 'Installments',
		description:
			'Payments under installment or buy-now-pay-later arrangements where the transaction represents repayment of a purchase over time.',
		examples: ['Anyday', 'Riverty', 'Telia Finance'],
	},
	{
		id: 'INSURANCE',
		title: 'Insurance',
		description:
			'Insurance premiums and related payments for home, vehicle, travel, pet, personal and other insurance coverage.',
		examples: ['Tryg', 'Topdanmark', 'Gjensidige'],
	},
	{
		id: 'INSURANCE_PAYOUT',
		title: 'Insurance payout',
		description: 'Money received from an insurer as a claim payout, settlement or insurance benefit.',
		examples: [
			'Property-damage claim settlement',
			'Travel-insurance claim payout',
			'Insurance reimbursement for a covered loss',
		],
	},
	{
		id: 'INTEREST',
		title: 'Interest',
		description: 'Interest income credited to an account or received from a financial product.',
		examples: ['Savings-account interest', 'Interest credited on a fixed-term deposit'],
	},
	{
		id: 'INVESTMENTS',
		title: 'Investments',
		description:
			'Payments or transfers associated with making or funding investments, such as brokerage, securities or crypto-investment activity.',
		examples: ['Saxo Bank', 'Trading 212', 'Coinbase'],
	},
	{
		id: 'INVESTMENT_RETURNS',
		title: 'Investment returns',
		description: 'Income generated from investments, including investment yield and distributions.',
		examples: ['Cash dividend', 'Investment-fund distribution', 'Investment-yield payment'],
	},
	{
		id: 'JEWELRY_AND_WATCHES',
		title: 'Jewelry & watches',
		description: 'Purchases from jewelry and watch retailers or purchases clearly identified as jewelry or watches.',
		examples: ['Pandora', 'Ditur', 'Vibholm Guld og Sølv'],
	},
	{
		id: 'LABOR_UNION',
		title: 'Labor union',
		description: 'Membership dues and payments to labor unions and trade unions.',
		examples: ['IDA', 'Djøf', 'Dansk Sygeplejeråd'],
	},
	{
		id: 'LAUNDRY_AND_DRY_CLEANING',
		title: 'Laundry & dry cleaning',
		description: 'Payments for laundry, laundromat and dry-cleaning services.',
		examples: ['Nortec', 'Byens Rens', 'Airwallet laundry payment'],
	},
	{
		id: 'LEISURE',
		title: 'Leisure & hobbies',
		description:
			'Payments for leisure and hobby activities, recreational memberships and related purchases, including musical instruments, recorded music and music equipment.',
		examples: ['Thomann', 'Gear4music', 'Sjællands Småbådsfiskeklub'],
	},
	{
		id: 'LOAN_UNSPECIFIED',
		title: 'Unspecified loan',
		description: 'Loan repayments where the specific loan type is not specified.',
		examples: [
			'Bank debit described only as a loan repayment',
			'Payment to a lender without an identified loan product',
		],
	},
	{
		id: 'MONEY_TRANSFERS',
		title: 'Money transfers',
		description:
			"Account-to-account and person-to-person money transfers, including transfers between a customer's own accounts and transfers to or from other people.",
		examples: ['MobilePay person-to-person transfer', 'Wise transfer', "Transfer between the same customer's accounts"],
	},
	{
		id: 'MORTGAGE',
		title: 'Mortgage',
		description:
			'Mortgage and mortgage-like home-financing payments that are identified specifically as mortgage debt.',
		examples: ['Totalkredit', 'Realkredit Danmark', 'Jyske Realkredit'],
	},
	{
		id: 'MOVING_SERVICES',
		title: 'Moving services',
		description: 'Payments to moving and relocation providers for transporting household or business belongings.',
		examples: ['Household moving company', 'Office relocation provider', 'Packing and removal service'],
	},
	{
		id: 'MUNICIPALITIES',
		title: 'Municipalities',
		description:
			'Payments to municipalities and local authorities, including local charges and services associated with the municipal relationship.',
		examples: ['Odense Kommune', 'Roskilde Kommune', 'Gribskov Kommune'],
	},
	{
		id: 'NURSING_HOMES',
		title: 'Nursing homes',
		description:
			'Payments for accommodation, care and related services provided by nursing homes and residential care facilities.',
		examples: ['Danske Diakonhjem', 'Diakonissestiftelsen', 'Holmegårdsparken'],
	},
	{
		id: 'OPTICIANS',
		title: 'Opticians',
		description:
			'Payments to opticians and eyewear providers for glasses, contact lenses and related optical products or services.',
		examples: ['Louis Nielsen', 'Synoptik', 'Profil Optik'],
	},
	{
		id: 'OTHER_ACTIVITY',
		title: 'Other financial activity',
		description:
			'Other financial activity and transactions that cannot be assigned to a more specific category from the available information. This includes both incoming and outgoing payments.',
		examples: [
			'Card payment with insufficient merchant or purpose information',
			'Account entry described only as a generic payment',
			'Other financial activity without a more specific category',
		],
	},
	{
		id: 'PARENTAL_LEAVE_PAY',
		title: 'Parental leave pay',
		description: 'Income paid during parental, maternity or paternity leave.',
		examples: [
			'Employer-paid maternity or paternity leave',
			'Public parental-leave benefit',
			'Parental-leave compensation payment',
		],
	},
	{
		id: 'PARKING',
		title: 'Parking',
		description: 'Payments for vehicle parking, parking subscriptions and parking operators.',
		examples: ['EasyPark', 'APCOA Flow', 'ParkZone'],
	},
	{
		id: 'PENSION',
		title: 'Pension',
		description:
			'Pension-related payments, including contributions paid into pension arrangements and pension income paid out to the customer.',
		examples: ['PFA', 'Danica Pension', 'Velliv'],
	},
	{
		id: 'PERSONAL_SERVICES_OTHER',
		title: 'Other personal services',
		description:
			'Other consumer and personal services, including postal services, parcel delivery, information services and general personal assistance.',
		examples: ['GLS parcel delivery', 'dao parcel delivery', 'Personal-assistance or concierge provider'],
	},
	{
		id: 'PHARMACY_AND_MEDICAL',
		title: 'Pharmacy & medical',
		description:
			'Payments to pharmacies and medical-supply providers, including pharmacy purchases, medical supplies and pharmacy-related delivery or service charges.',
		examples: ['Apopro.dk', 'Med24.dk', 'Randers Sønderbros Apotek'],
	},
	{
		id: 'PROFESSIONAL_AND_ADVISORY_SERVICES',
		title: 'Professional & advisory services',
		description:
			'Payments for professional advice and specialist services such as legal, tax, engineering, architectural, translation or consulting work.',
		examples: ['Legal Desk', 'TestaViva', 'Architecture or engineering consultancy'],
	},
	{
		id: 'PROPERTY_TAX',
		title: 'Property tax',
		description: 'Taxes or public charges specifically related to property ownership.',
		examples: ['Property-ownership tax payment', 'Tax charge relating to a specific property'],
	},
	{
		id: 'PUBLIC_BENEFITS_UNSPECIFIED',
		title: 'Unspecified public benefits',
		description: 'Public-benefit payments where the specific benefit type is not specified.',
		examples: [
			'Government payment described only as a benefit',
			'Public-support payment without an identified benefit program',
		],
	},
	{
		id: 'PUBLIC_DEBT',
		title: 'Public debt',
		description: 'Repayments of debt owed to a public authority or government debt-collection body.',
		examples: ['Gældsstyrelsen', 'Repayment under a public-debt payment plan'],
	},
	{
		id: 'PUBLIC_TRANSPORT',
		title: 'Public transit',
		description:
			'Payments for train, bus, tram and metro travel, including individual tickets, passes and public-transit travel cards.',
		examples: ['DSB', 'Rejsekort', 'Midttrafik'],
	},
	{
		id: 'RENT',
		title: 'Rent',
		description: 'Rent payments to landlords or housing providers, and rental income received from tenants.',
		examples: ['Vores Bolig rent payment', 'Cityhuset rent payment', 'Rental income received from a tenant'],
	},
	{
		id: 'RESTAURANTS',
		title: 'Restaurants',
		description: 'Payments at sit-down restaurants, bistros, diners and other general dining venues.',
		examples: ['Madklubben', "Sticks'n'Sushi", 'Independent sit-down restaurant or bistro'],
	},
	{
		id: 'ROADSIDE_ASSISTANCE',
		title: 'Roadside assistance',
		description: 'Payments for roadside-assistance memberships and vehicle breakdown assistance.',
		examples: ['FDM', 'SOS Dansk Autohjælp', 'Falck roadside assistance'],
	},
	{
		id: 'SALARY',
		title: 'Salary',
		description: 'Regular employment salary or wage income.',
		examples: ['Monthly salary deposit', 'Weekly or biweekly wage payment'],
	},
	{
		id: 'SCHOLARSHIPS',
		title: 'Scholarships',
		description: 'Incoming scholarship funding for education or study.',
		examples: ['University scholarship', 'Private-foundation study scholarship'],
	},
	{
		id: 'SHOPPING_OTHER',
		title: 'Other shopping',
		description:
			'Other retail purchases, including secondhand and resale shops, florists, gift shops, general marketplaces and retailers with mixed product ranges.',
		examples: ['Blå Kors Genbrug', 'Børneloppen', 'Florist, gift shop or general online marketplace'],
	},
	{
		id: 'SICKNESS_BENEFITS',
		title: 'Sickness benefits',
		description:
			'Incoming sickness-benefit payments made during eligible periods of illness or reduced ability to work.',
		examples: ['Danish sygedagpenge payment', 'Statutory sickness-benefit payment'],
	},
	{
		id: 'SOCIAL_ASSISTANCE',
		title: 'Social assistance',
		description:
			'Public financial assistance and targeted social-support payments, including cash assistance and support for essential living expenses.',
		examples: [
			'Danish kontanthjælp payment',
			'Needs-based cash assistance',
			'Targeted financial support for essential living costs',
		],
	},
	{
		id: 'SPECIALTY_FOOD_STORES',
		title: 'Specialty food stores',
		description:
			'Purchases from specialist food retailers, including bakeries, butchers, fishmongers, confectionery shops, delicatessens, ethnic grocery stores and other specialty food shops.',
		examples: ['Lagkagehuset', 'Frellsen', 'Fiskekutteren.dk'],
	},
	{
		id: 'SPORTS_AND_OUTDOORS',
		title: 'Sports & outdoors',
		description:
			'Payments for sports and outdoor activities, memberships, sporting goods, sportswear and outdoor equipment.',
		examples: ['SPORT 24', 'Boulders', 'Kokkedal Golfklub'],
	},
	{
		id: 'STATE_EDUCATION_GRANTS',
		title: 'Government student grants',
		description: 'Incoming government student grants or public education-support payments.',
		examples: ['Danish SU payment', 'Government student-support grant'],
	},
	{
		id: 'STORAGE',
		title: 'Storage',
		description: 'Payments for physical storage and warehousing services, including self-storage facilities.',
		examples: ['Nettolager', 'BOXIT', 'Shurgard Self-Storage'],
	},
	{
		id: 'STREAMING',
		title: 'Streaming',
		description:
			'Payments for video, music, audio and other digital-media streaming services, including subscriptions and individual content purchases.',
		examples: ['Netflix', 'Spotify Premium', 'TV 2 Play'],
	},
	{
		id: 'STUDENT_LOAN',
		title: 'Student loan',
		description: 'Repayments on student or education loans where the loan is specifically identified as student debt.',
		examples: ['Studielån - Udbetaling Danmark', 'Repayment of an education loan'],
	},
	{
		id: 'SUPERMARKETS',
		title: 'Supermarkets',
		description: 'Purchases from supermarkets and general grocery retailers, including online supermarket purchases.',
		examples: ['Netto', 'REMA 1000', 'nemlig.com'],
	},
	{
		id: 'TAX_REFUNDS',
		title: 'Tax refunds',
		description: 'Money received back from a tax authority as a tax refund or repayment of overpaid tax.',
		examples: ['Annual tax refund', 'Repayment of overpaid tax'],
	},
	{
		id: 'TELECOM',
		title: 'Phone, internet & TV',
		description: 'Payments for phone, internet, television and bundled connectivity services.',
		examples: ['Hiper', 'Lebara', 'YouSee'],
	},
	{
		id: 'TOURS_AND_ATTRACTIONS',
		title: 'Tours & attractions',
		description:
			'Payments to tourist attractions and sightseeing providers, including guided tours and sightseeing experiences.',
		examples: ['GetYourGuide sightseeing tickets', 'Egeskov', 'Guided city-tour operator'],
	},
	{
		id: 'TRANSPORT_OTHER',
		title: 'Other transport',
		description:
			'Other personal-mobility and vehicle-related payments, including bicycle suppliers, marine services and specialist passenger transport.',
		examples: ['Cykelgear.dk', 'Juelsminde Havn mooring payment', 'Specialist passenger-transfer provider'],
	},
	{
		id: 'TRANSPORT_TOLLS',
		title: 'Road & bridge tolls',
		description: 'Road, bridge and similar transport tolls charged for using transport infrastructure.',
		examples: ['Storebælt', 'Øresundsbron', 'Brobizz'],
	},
	{
		id: 'TRAVEL_BOOKING_AND_PACKAGES',
		title: 'Travel booking & packages',
		description:
			'Payments to travel agencies and booking providers, as well as packaged travel products where transport, accommodation or other travel components are sold together.',
		examples: ['Spies', 'TUI', 'Bravo Tours'],
	},
	{
		id: 'TRAVEL_OTHER',
		title: 'Other travel',
		description:
			'Other travel-related services, including travel assistance and travel-document or visa-processing services.',
		examples: ['Travel-assistance provider', 'Travel-document or visa-processing service'],
	},
	{
		id: 'UNEMPLOYMENT_BENEFITS',
		title: 'Unemployment benefits',
		description: 'Income received as unemployment benefits.',
		examples: ['Danish dagpenge payment', 'Unemployment-benefit deposit'],
	},
	{
		id: 'UNEMPLOYMENT_INSURANCE',
		title: 'Unemployment insurance',
		description: 'Membership payments to unemployment-insurance funds or schemes, such as Danish A-kasser.',
		examples: ['Akademikernes A-kasse', 'A&Til', 'Ase A-kasse'],
	},
	{
		id: 'VACATION_PAY',
		title: 'Vacation pay',
		description: 'Income identified as vacation or holiday pay.',
		examples: ['FerieKonto vacation-pay payout', 'Accrued vacation allowance paid out'],
	},
	{
		id: 'VEHICLE_FUEL',
		title: 'Vehicle fuel',
		description: 'Purchases of gasoline, diesel and other vehicle fuels from fuel retailers and service stations.',
		examples: ['OK', 'Circle K', 'Q8'],
	},
	{
		id: 'VEHICLE_LEASING',
		title: 'Vehicle leasing',
		description: 'Recurring and one-off payments under vehicle-leasing agreements.',
		examples: ['Nordania Finans', 'Toyota leasing', 'Ayvens'],
	},
	{
		id: 'VEHICLE_LOAN',
		title: 'Vehicle loan',
		description: 'Repayments on loans used to finance a car or other vehicle.',
		examples: ['AL Finans', 'Hyundai Finans', 'Dedicated vehicle-finance provider'],
	},
	{
		id: 'VEHICLE_MAINTENANCE_AND_REPAIR',
		title: 'Vehicle maintenance & repair',
		description: 'Payments for vehicle maintenance, repairs, servicing, parts, inspections, tires and car washes.',
		examples: ['Quickpoint', 'Wash World', 'thansen'],
	},
	{
		id: 'VEHICLE_TAX',
		title: 'Vehicle tax',
		description: 'Taxes and public charges specifically related to owning or registering a vehicle.',
		examples: ['Skat - Motorafgifter', 'Annual vehicle-ownership tax', 'Vehicle-registration tax payment'],
	},
	{
		id: 'WAITING_LIST_FEES',
		title: 'Waiting list fees',
		description: 'Fees for joining or remaining on a waiting list, including housing waiting lists.',
		examples: ['AarhusBolig waiting-list fee', 'FSB waiting-list fee', 'Waitly'],
	},
	{
		id: 'WATER_AND_WASTE',
		title: 'Water, sewer & waste',
		description:
			'Payments for water supply, wastewater and sewer services, garbage collection and related waste-management services.',
		examples: ['BlueKolding Vand', 'Greve Spildevand', 'Municipal waste-collection service'],
	},
	{
		id: 'WELLNESS_AND_SPA',
		title: 'Wellness & spa',
		description:
			'Payments for wellness and relaxation services such as massage, sauna, spa treatments, holistic wellness and wellness retreats.',
		examples: ['RaskRask', 'Sauna House', 'Massage studio or spa'],
	},
]
